import { Card, Button } from "@chef/components";
import { formatDate } from "@chef/helpers";
import { Delivery } from "@chef/icons/small";
import { Modal } from "@chef/smart-components";

import { intl } from "./AddressChangedAfterCutoffModal.Intl";

export const AddressChangedAfterCutoffModal = ({
  nextDeliveryDate,
  onClose,
  onConfirm,
  show,
}: {
  nextDeliveryDate?: Date;
  onClose: () => void;
  onConfirm: () => void;
  show: boolean;
}) => {
  const formatedDeliveryDate =
    nextDeliveryDate && formatDate(nextDeliveryDate, "dd LLLL");

  return (
    <Modal open={show} onClose={onClose} size="md">
      <div>
        <Card
          className="flex flex-col items-center px-6 pb-6 mt-20 text-center pt-18"
          noPadding
        >
          <Delivery className="w-36 h-36 md:w-20 md:h-20" />

          <h2 className="mt-6">
            {intl.A_DELIVERY_IS_UNDERWAY_TO_YOUR_OLD_ADDRESS}
          </h2>

          <p className="mt-2">
            {intl.YOUR_CHANGE_IS_VALID_FROM}{" "}
            <strong>{formatedDeliveryDate}.</strong>{" "}
            {
              intl.YOU_HAVE_PREVIOUSLY_REQUESTED_A_DELIVERY_THAT_IS_BEING_SENT_TO_YOUR_OLD_ADDRESS
            }
          </p>

          <div className="flex flex-col gap-4">
            <Button
              primary
              onClick={onConfirm}
              className="mt-8 self-stretch md:self-center md:w-[200px]"
            >
              {intl.SAVE_CHANGES}
            </Button>

            <Button outlined onClick={onClose}>
              {intl.CANCEL}
            </Button>
          </div>
        </Card>
      </div>
    </Modal>
  );
};
